module.exports = __webpack_public_path__ + "media/fonts/Oricons-38447c0d5b29cdec6586206620c4843e.svg";